import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(async () => {
    const Appointments = await import("@lexus.com/ui/dist/applications/ServiceScheduler/appointments")
    return Appointments;
});

const SchedulerDashboardEditConfig = {
    emptyLabel: "Service Scheduler Dashboard",
    isEmpty: function (props) {
        return !props || !props.title || props.title.trim().length < 1;
    },
};

/**
 * Temp fn to build paths for the sst-icons
 */
const getIconPath = (brandTheme) => {
    if (brandTheme === 'LCOM') {
        return '/content/dam/lexus/images/icons/sst-icons';
    } else if (brandTheme === 'TCOM') {
        return '/content/dam/toyota/sst/icons';
    } else {
        return null;
    }
}

const transformData = (props) => {

    const { brandTheme, enablePricing, summary, sectionBlocks } = props;
    const brand = brandTheme === 'LCOM' ? 'L' : 'T';

    let iconPath = getIconPath(brandTheme);

    return {
        source: brandTheme,
        brand,
        theme: {
            brand: brandTheme === 'LCOM' ? 'Lexus' : 'Toyota',
        },
        pricing: enablePricing,
        heading: props.appointmentsHeading,
        subheading: props.appointmentsSubHeading,
        pageTitle: props?.pageHeading || "Service",  // TODO: Missing Prop
        CTAButtonLabel: "Schedule Service", // TODO: Missing Prop
        tabs: [
            {
                tabTitle: props.upcomingTabLabel,
                subtitle: props.upcomingTabCountMessage,
                id: props.upcomingTabId,
                noItemMessage: props.upcomingNoAppointmentsMessage
            },
            {
                tabTitle: props.pastTabLabel,
                subtitle: props.pastTabCountMessage,
                id: props.pastTabId,
                noItemMessage: props.pastNoAppointmentsMessage
            }
        ],
        telephoneNames: (props?.phoneNumbers || []).map(phoneNumber => ({
            key: phoneNumber.key,
            displayName: phoneNumber.label || ""
        })),
        vinCopy: props.vinCopy,
        cancelLabelCTA: props.cancelAppointmentCTA.text,
        editLabelCTA: props.editAppointmentCTA.text,
        cancelledAppointmentTagLabel: props.canceledAppointmentLabel,
        serviceHistoryLabel: props.serviceHistoryCTA.text,
        serviceHistoryRedirect: props.serviceHistoryCTA?.href,
        ghostJellyImage: {
            src: props.ghostJellyImage?.src,
            alt: props.ghostJellyImage?.alt || '',
            role: props.ghostJellyImage?.role || '',
        },
        summaryItemList: sectionBlocks?.map(section => {
            return {
                heading: section?.heading,
                content: section?.content,
                editLabel: summary?.edit,
                stepIndex: section?.stepIndex,
                moreDetails: section?.moreDetails,
            }
        }),
        serviceDetailProps: {
            title: props.serviceDetailsHeading,
            customServiceCopy: props.serviceDetailsCustomerServiceText,
            disclaimer: props.serviceDetailsDisclaimer,
            contactDealerCopy: props.serviceDetailsContactDealerText,
            estimatedTotalCopy: props.serviceDetailsEstimatedTotalText,
            additionalCommentsCopy: props.serviceDetailsAdditionalCommentsText,
            telephoneIcon: props.serviceDetailsContactDealerIcon?.src,
            estimatedTotalContactDealerCopy: props.serviceDetailsEstimatedTotalContectDealerText,
        },
        noAppointmentsIcon: props.noAppointmentsMessageIcon?.src,
        serverErrorMessage: {
            title: props.serverErrorMessageHeading,
            subtitle: props.serverErrorMessageCopy
        },
        cancelMessage: {
            title: props?.cancelAppointmentModal?.heading || "Cancel Appointment?",
            body: props?.cancelAppointmentModal?.body || "Are you sure you want to cancel your service appointment with {dealerName}?",
            ctaCopy: props.cancelAppointmentModal?.cta?.text || "Cancel Appointment",
            icon: props?.cancelAppointmentModal?.icon?.src || (brandTheme === 'TCOM' && `${iconPath}/ErrorIcon.svg`),
        },
        //TODO missing props
        errorMessage: {
            icon: props?.cancelFailureModal?.icon?.src || ((brand !== "L") && `${iconPath}/fail.svg`), // Lexus is not showing icon
            // title: props?.cancelFailureModal?.heading ||
            title: (brand !== "L") ? "Something Went Wrong" : "SOMETHING WENT WRONG",
            // subtitle: props?.cancelFailureModal?.body ||
            subtitle:  `<p>There was an issue canceling the appointment. Please try again.</p>\n<p>If this problem persists, please contact {dealerName} at&nbsp; <a href={\`tel:\${phoneNumber}\`}>{phoneNumber}</a> directly to cancel the appointment.</p>\n`,
            ctas: []
        },
        successMessage: {
            title: props?.cancelSuccessModal?.heading || "Success!",
            body: props?.cancelSuccessModal?.body || "Your service appointment with {dealerName} has been cancelled.",
            icon: props?.cancelSuccessModal?.icon?.src || (brandTheme === 'TCOM' && `${iconPath}/success.svg`),
        },
        // TODO: Missing prop for content-fragment
        editMessage: {
            title: props?.editAppointmentModal?.heading,
            body: props?.editAppointmentModal?.body,
            ctaCopy: props.editAppointmentModal?.cta?.text,
        },
        editAppointmentRedirect: props?.editAppointmentRedirectCTA?.href || props?.editAppointmentCTA?.href, // TODO: Check if we can use this for the redirect
        contactDealerToCancel: {
            title: props?.cancelAppointmentContactDealerModal?.heading || "Contact Dealer to Cancel",
            body: props?.cancelAppointmentContactDealerModal?.body || "Please contact {dealerName} to cancel your service appointment",
            ctaCopy: props?.cancelAppointmentContactDealerModal?.cta?.text || "Visit website",
        },
        // TODO: Missing Content fragment field under modals.
        contactDealerToEdit: {
            title: props?.editContactDealerModal?.heading || "Contact Dealer to Edit",
            body: props?.editContactDealerModal?.body || "Please contact {dealerName} to make changes to your service appointment",
            ctaCopy: props?.editContactDealerModal?.cta?.text || "Visit website",
        },
        loader: {
            indeterminateIcon: props?.loaderIndeterminateIcon?.src,
            indeterminateText: props?.loaderIndeterminateText
        },
        scheduleTimeFormat: props?.appointmentSummaryFormat,
        appointmentChangeMessage: props?.appointmentChangeMessage,
        pagination:{
            icon: props?.paginationIcon?.src,
            text: props?.paginationText || "{currentPage} of {totalPages}",
            appointmentsPerPage:props?.appointmentsPerPage || 5
        }
    }
}

const SchedulerDashboardConfig = (props) => {
    const data = transformData(props);
    return <Component {...data} />;
};

export default withAemIntegration("lexus/components/service-scheduler-dashboard")(SchedulerDashboardConfig, SchedulerDashboardEditConfig);